import loadable from '@loadable/component';

import coreInputTypes from '../../../../core/views/partials/input-types';

const inputTypes = {
	...coreInputTypes,
	hidden: loadable(() => import('/views/partials/input-types/hidden')),
};

export default inputTypes;
